import { render, staticRenderFns } from "./PostPartners.vue?vue&type=template&id=cf4c2858"
import script from "./PostPartners.vue?vue&type=script&lang=js"
export * from "./PostPartners.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports